import AwsAmplifyApi from "../../utility/AwsAmplifyApi";
import { APIEndpoints, APIPaths } from "../../config/APIEndpoints";

import { loaderActions, errorActions } from ".";
import { LoaderContent } from "../../utility/constants/LoaderContent";

export const UPDATE_SERVICE_SUBSCRIPTIONS = "UPDATE_SERVICE_SUBSCRIPTIONS";
export const UPDATE_SERVICES = "UPDATE_SERVICES";
export const ADD_SERVICE_SUBSCRIBED = "ADD_SERVICE_SUBSCRIBED";

export const UPDATE_ANNOUNCEMENTS = "UPDATE_ANNOUNCEMENTS";
export const UPDATE_ANNOUNCEMENTS_VISIBILITY = "UPDATE_ANNOUNCEMENTS_VISIBILITY";

export const setServices = services => ({
    type: UPDATE_SERVICES,
    payload: services,
})

export const updateServiceSubscriptions = serviceSubscriptions => ({
    type: UPDATE_SERVICE_SUBSCRIPTIONS,
    payload: serviceSubscriptions,
})

export const addNewServiceSubscribed = service => ({
    type: ADD_SERVICE_SUBSCRIBED,
    payload: service,
})

export const updateAnnouncements = announcements => ({
    type: UPDATE_ANNOUNCEMENTS,
    payload: announcements,
})

export const updateAnnouncementsVisibility = displayStatus => ({
    type: UPDATE_ANNOUNCEMENTS_VISIBILITY,
    payload: displayStatus,
})

const updateErrorCode = err => dispatch => {
  dispatch(errorActions.resetCustomAuthenticationErrorCode(err));
};

//******** fetch all services

const fetchServicesAPI = () => async dispatch => {
    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.PLATFORM_SERVICES;
    return await dispatch(AwsAmplifyApi.get({apiName, apiPath,excludeClinicHeader:true}));
}

export const fetchServices = () => async dispatch =>{
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.PLATFORM_CORE_SERVICES));
        const response = await dispatch(fetchServicesAPI());
        if(response.error.code) {
            throw response.error
        }
        dispatch(setServices(response.data));
        dispatch(loaderActions.stopAppLoader())
    } catch (error) {
        dispatch(loaderActions.stopAppLoader())
        const services=[];
        dispatch(setServices(services));
        throw error;
    }
}

//********* fetch subscribed services */

const fetchSubscribedServicesApi = (clinicId) => async dispatch =>{
    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.PLATFORM_SERVICES_SUBSCRIBED;
    return await dispatch(AwsAmplifyApi.get({apiName, apiPath,clinicId}));
}

export const fetchSubscribedServices = (clinicId) => async dispatch =>{
    try{
            dispatch(updateErrorCode(undefined));
            const response = await dispatch(fetchSubscribedServicesApi(clinicId));
            // TODO - Need to handle error appropriately
            // if(response.error.code){
            //     throw response.error;
            // }
            dispatch(updateServiceSubscriptions(response.data));
    }catch(error) {
        const services=[];
        dispatch(setServices(services));
        if(error.response.status === 403){
            dispatch(updateErrorCode(403));
        }
    }
}

//******** Update subscribed services */

const updateServiceSubscriptionApi = (clinicId, serviceSubscriptions) => async dispatch =>{
    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.PLATFORM_SERVICES_SUBSCRIBED;
    const body = {serviceSubscriptions};
    return await dispatch(AwsAmplifyApi.post({apiName, apiPath, clinicId,body}));
}


export const updateServiceSubscriptionDetails = (clinicId, serviceSubscriptions) => async dispatch =>{
    try{
        dispatch(loaderActions.startAppLoader(LoaderContent.UPDATE_PLATFORM_CORE_SUBSCRIBED_SERVICES));
        //const response =
        await dispatch(updateServiceSubscriptionApi(clinicId,serviceSubscriptions));
        // TODO - Need to handle appropriately
        // if(response.error.code) {
        //     throw response.error
        // }
        dispatch(loaderActions.stopAppLoader());
    }
    catch(error){
        dispatch(loaderActions.stopAppLoader());
        throw error
    }
}

//********* add new platform service */

const fetchAddNewPlatformServiceApi = (clinicId, serviceDetails) => async dispatch =>{
    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.ADD_NEW_PLATFORM_SERVICE;
    const body = {
        service_name: serviceDetails.service_name,
        service_description: serviceDetails.service_description,
        is_active: serviceDetails.is_active,
        display_order: serviceDetails.display_order
    };
    return await dispatch(AwsAmplifyApi.post({apiName, apiPath, clinicId,body}));
}

export const addNewPlatformService = (selectedClinicId, serviceDetails) => async dispatch =>{
    try{
        dispatch(loaderActions.startAppLoader(LoaderContent.ADD_NEW_PLATFORM_CORE_SERVICE));
        await dispatch(fetchAddNewPlatformServiceApi(selectedClinicId, serviceDetails));
        dispatch(fetchServices(selectedClinicId));
        dispatch(loaderActions.startAppLoader());
    }catch(_e){
        dispatch(loaderActions.stopAppLoader());
    }
}

//********* update the details of existing platform service */

const fetchUpdatePlatformServiceDetailsApi = (clinicId, serviceDetails) => async dispatch=>{
    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.UPDATE_PLATFORM_SERVICE_DETAILS(serviceDetails.service_id);
    const body = {
        service_name: serviceDetails.service_name,
        service_description: serviceDetails.service_description,
        is_active: serviceDetails.is_active,
        display_order: serviceDetails.display_order
    };
    return await dispatch(AwsAmplifyApi.put({apiName, apiPath, clinicId,body}));
}

export const updatePlatformServiceDetails = (selectedClinicId,serviceDetails) => async dispatch =>{
    try{
        dispatch(loaderActions.startAppLoader(LoaderContent.UPDATE_PLATFORM_CORE_SERVICE));
        await dispatch(fetchUpdatePlatformServiceDetailsApi(selectedClinicId, serviceDetails));
        dispatch(fetchServices(selectedClinicId));
        dispatch(loaderActions.stopAppLoader());
    }catch(_e){
        dispatch(loaderActions.stopAppLoader());
    }
}

//********* fetch Announcements */

const fetchAnnouncementsApi = async () => {

    const url = `${APIEndpoints.NHCAPI.endpoint}${APIPaths.ANNOUNCEMENT}`;
    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json"
    }
    const response = await fetch(url, {method: "get", headers});
    return response.json();

}

const fetchAnnouncementsApi2 =  () => async dispatch=>{

    const apiName = APIEndpoints.NHCAPI.name;
    const apiPath = APIPaths.ANNOUNCEMENT;
    return await dispatch(AwsAmplifyApi.get({apiName, apiPath,excludeClinicHeader:true}));

}

export const fetchAnnouncements = () => async dispatch => {
    try{
        const response = await dispatch(fetchAnnouncementsApi2());
        dispatch(updateAnnouncements(response.data));
    }catch(error) {
        dispatch(updateAnnouncements([]));
        throw error;
    }

}
